import { ObjectHelpers } from "../../helpers/object-helpers";

export class CompanyProfileDataModel {
    public symbol = ''; 
    public country = ''; 
    public summary = ''; 
    public website = ''; 
   
    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}
